module.exports = __webpack_public_path__ + "img/icon-notifications.ba8b4079.svg";